import { Paginator } from "primereact/paginator";
import { useContext, useRef, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import { generateSequentialArray } from "../../common/utils";
import CommentModal from "../CommentModal/CommentModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import {
  Container,
  FakeRow,
  TableHeader,
} from "../DocumentManagement/DocumentManagementSharedStyles";
import FileUploadCreditModal from "../FileUploadCreditModal/FileUploadCreditModal";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import { CreditAuthFilters, INITIAL_FILTERS } from "./CreditAuthFilters";
import { Title } from "./CreditAuthStyles";
import CreditInvoices from "./CreditInvoices";
import useFetchAffectedVolantes from "./useFetchAffectedVolantes";
const ITEMS_PER_PAGE = 10;
const GRID_TEMPLATE_COLUMNS = "1fr 15rem 20rem 15rem";

const auxiliaryArray = generateSequentialArray(ITEMS_PER_PAGE);

const getTitles = (useDollars) => ({
  payerRuc: "RUC PAGADOR",
  status: "ESTADO",
  billableRuc: "RUC FACTURABLE",
  amount: `MONTO (${useDollars ? "DÓLARES" : "SOLES"})`,
  actions: "ACCIONES",
});

function ThirdPartyAuth() {
  const [, updateVolanteComment] = useState("");
  const [showCommentModal, updateShowCommentModal] = useState(false);
  const [showModal, updateShowModal] = useState(false);
  const [selectedVolante, updateSelVolante] = useState(0);
  const [filters, updateFilters] = useState(INITIAL_FILTERS);

  const updateSelected = (volante) => {
    updateSelVolante(volante.id);
    updateVolanteComment(volante.creditAuthComment);
    updateShowCommentModal(true);
  };

  const toggleCommentModal = () => {
    updateShowCommentModal(!showCommentModal);
  };

  const [messageError, updateMessageError] = useState("");
  const onErrorMessage = (msg) => {
    updateMessageError(msg);
    toggleGetModal();
  };
  const onRemoveInvoice = () => updateShowModalGenerateQuotation(false);
  const [invoicesRows, dataInvoices, removeInvoice] = useFetchAffectedVolantes(
    filters,
    onErrorMessage,
    onRemoveInvoice
  );

  const [showModalGenerateQuotation, updateShowModalGenerateQuotation] =
    useState(false);

  const toggleModalGenerateQuotation = () => {
    updateShowModalGenerateQuotation(!showModalGenerateQuotation);
  };

  const selectedRow = useRef(null);
  const [showModalError, updateShowModalError] = useState(false);

  const toggleGetModal = () => {
    updateShowModalError(!showModalError);
  };

  const retryTable = () => {
    updateShowModal(false);
    dataInvoices.retry();
  };

  const [useDollars] = useContext(CurrencyContext);
  const titles = getTitles(useDollars);

  return (
    <div>
      {showModalError && messageError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            updateShowModalGenerateQuotation(false);
            toggleGetModal();
          }}
          title={`Atención`}
          toggleModal={() => {
            updateShowModalGenerateQuotation(false);
            toggleGetModal();
          }}
        />
      )}
      <Title>Mis Autorizaciones</Title>
      <Authorization actions={["invoice.get_invoice_payment_status"]}>
        <CreditAuthFilters
          onQuery={(filters) => {
            dataInvoices.execute({ filters });
            updateFilters(filters);
          }}
        />
      </Authorization>

      {dataInvoices.isSuccess && invoicesRows.length === 0 ? (
        <StandaloneMessage>
          No se encontraron parámetros de autorización de crédito.
        </StandaloneMessage>
      ) : dataInvoices.isLoading || dataInvoices.isSuccess ? (
        <Container gridTemplateColumns={GRID_TEMPLATE_COLUMNS}>
          <Authorization actions={["invoice.get_invoice_payment_status"]}>
            <TableHeader className="item-container">
              <div className="left-align">{titles.payerRuc}</div>
              <div>{titles.status}</div>
              <div>{titles.amount}</div>
              <div>{titles.actions}</div>
            </TableHeader>
          </Authorization>
          {dataInvoices.isSuccess ? (
            <Authorization actions={["invoice.get_invoice_payment_status"]}>
              <CreditInvoices
                invoices={invoicesRows}
                updateShowModal={updateShowModalGenerateQuotation}
                updateSelected={updateSelected}
                selectedRow={selectedRow}
                useDollars={useDollars}
                titles={titles}
              />
            </Authorization>
          ) : (
            auxiliaryArray.map((_, index) => {
              return <FakeRow key={index} />;
            })
          )}
          {dataInvoices.isSuccess && (
            <div className="flex-paginator">
              <Authorization actions={["invoice.get_invoice_payment_status"]}>
                <Paginator
                  first={
                    (dataInvoices.data.page - 1) * dataInvoices.data.page_size
                  }
                  rows={dataInvoices.data.page_size}
                  totalRecords={dataInvoices.data.count}
                  onPageChange={(e) => {
                    const targetPage = e.first / dataInvoices.data.page_size;
                    dataInvoices.execute({ page: targetPage + 1, filters });
                  }}
                />
              </Authorization>
            </div>
          )}
          {showCommentModal && (
            <CommentModal
              toggleModal={toggleCommentModal}
              title="Documento rechazado"
              message={selectedRow?.current?.invoice_rejected_comment}
              onAccept={() => {
                updateShowModal(true);
                toggleCommentModal();
              }}
            />
          )}
          {showModalGenerateQuotation && (
            <ConfirmModal
              toggleModal={toggleModalGenerateQuotation}
              title="¿Deseas volver a generar las facturas?"
              message="Se eliminaran los registros del estado de validación y tendras que volver a generar la factura."
              haveAccept
              labelOnAccept="Volver a generar la factura"
              waitingForServerResponse={removeInvoice.isLoading}
              onAccept={() => {
                const selectedRows = selectedRow.current;
                removeInvoice.execute({ selectedRows });
              }}
            ></ConfirmModal>
          )}
          {showModal ? (
            <FileUploadCreditModal
              dataInvoicesRefresh={retryTable}
              rowData={selectedRow.current}
              volanteId={selectedVolante}
              hideModal={() => updateShowModal(false)}
            />
          ) : null}
        </Container>
      ) : null}
    </div>
  );
}
export default ThirdPartyAuth;
